import React from 'react';
import SectionsContainer from './Sections/SectionsContainer.js';
import './index.css';

function App() {
  return (
    <div className="App">
      <SectionsContainer />
    </div>
  );
}

export default App;
